/**
 * Seam Login Modal
 * Vanilla JS — no jQuery dependency
 */
(function () {
  'use strict';

  var modal   = document.getElementById('seam-login-modal');
  var overlay = document.getElementById('seam-login-overlay');
  if (!modal) return;

  var views = {
    login:    modal.querySelector('[data-seam-login-view="login"]'),
    register: modal.querySelector('[data-seam-login-view="register"]'),
    forgot:   modal.querySelector('[data-seam-login-view="forgot"]')
  };

  /* ── Helpers ──────────────────────────────────── */
  function focusFirst(viewEl) {
    if (!viewEl) return;
    var inp = viewEl.querySelector('input:not([type="hidden"])');
    if (inp) inp.focus();
  }

  /* ── Open / Close ────────────────────────────── */
  function open(viewName) {
    switchView(viewName || 'login');
    modal.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      focusFirst(modal.querySelector('.seam-login__view.is-active'));
    }, 300);
  }

  function close() {
    modal.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function switchView(name) {
    Object.keys(views).forEach(function (key) {
      if (!views[key]) return;
      if (key === name) {
        views[key].classList.add('is-active');
        views[key].style.display = '';
      } else {
        views[key].classList.remove('is-active');
        views[key].style.display = 'none';
      }
    });
  }

  /* ── Event delegation ────────────────────────── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-seam-login-trigger]');
    if (trigger) {
      e.preventDefault();
      open('login');
      return;
    }

    if (e.target.closest('[data-seam-login-close]')) {
      close();
      return;
    }

    if (e.target === overlay) {
      close();
      return;
    }

    var sw = e.target.closest('[data-seam-login-switch]');
    if (sw) {
      var target = sw.getAttribute('data-seam-login-switch');
      switchView(target);
      setTimeout(function () { focusFirst(views[target]); }, 50);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      close();
    }
  });

  /* ── Public API ──────────────────────────────── */
  window.seamLoginModal = { open: open, close: close };

})();
